/* eslint-disable import/prefer-default-export */
import type {
  ObjectSummaryInfo,
  ObjectCount
} from '@src/endpoints/services/graphQueryMgr.service'

export interface ObjectItem extends ObjectSummaryInfo {
  account_name?: string
  object_type?: string
  actions_ut?: {
    READ?: string
    WRITE?: string
    ADMIN?: string
  }
  actions_str: string
  alerts?: string
}
export interface ObjectChartItem extends ObjectCount {}

// Reducer
export const defaultState = {
  objectList: [] as ObjectItem[],
  isPending: false
}

export type ObjectsState = typeof defaultState
